import { render, staticRenderFns } from "./MemberApproval.vue?vue&type=template&id=9ea21b5e&"
import script from "./MemberApproval.vue?vue&type=script&lang=js&"
export * from "./MemberApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports